import { REQUEST_STATUSES, SECTIONS } from "@/constants/index.js";
import store from "@/store/index.js";

import { iconsSelector } from "./selectors.js";
import * as types from "./types.js";
import { IconService } from "../../../services";
import { queriesSelector } from "../queries/selectors.js";

export const getIcons = (propertyId, query) => {
  return async (dispatch) => {
    dispatch({
      type: types.SET_ICONS_REQUEST_STATUS,
      payload: { propertyId, status: REQUEST_STATUSES.LOADING },
    });

    const { resp, status, err } = await IconService.getIcons(propertyId, query);

    dispatch({
      type: types.GET_ICONS,
      payload: { propertyId, icons: resp?.data || [], count: resp?.count, status, err, query },
    });
  };
};

export const getIconsWithQuery = (propertyId) => {
  return async (dispatch) => {
    const state = store.getState();
    const { icons } = iconsSelector(propertyId)(state);

    const {
      offset,
      limit,
      sortField,
      sortOrientation,
      searchText = "",
    } = queriesSelector(SECTIONS.ICONS, `properties/${propertyId}/icons`)(state);

    const query = {
      sortField,
      sortOrientation,
    };

    if (offset || limit) {
      query.offset = icons.length ? offset : 0;
      query.limit = limit;
    }

    if (searchText) {
      query.searchText = searchText.trim().toLowerCase();
    }

    dispatch(getIcons(propertyId, query));
  };
};
